import React, { useState } from 'react';
import MeetupForm from './components/MeetupForm';
import ClubForm from './components/ClubForm';
import { useAuth } from './AuthContext';

function OpenToPlayTabs({ onTriggerLogin }) {
    const [activeTab, setActiveTab] = useState('now');
    const { user } = useAuth();

    if (!user) {
        return (
            <div className="bg-white p-6 rounded-lg shadow-md text-center">
                <h3 className="text-lg font-semibold text-gray-800 mb-2">Want to Host or Join a Game?</h3>
                <p className="text-gray-600 mb-4">Log in to post your availability<br />or schedule a meetup.</p>
                <button
                    onClick={onTriggerLogin}
                    className="bg-indigo-600 text-white px-6 py-2 rounded-lg font-medium hover:bg-indigo-700 transition-colors"
                >
                    Login / Sign Up
                </button>
            </div>
        );
    }

    return (
        <div className="bg-white p-4 rounded-lg shadow-md">
            <div className="mb-4 flex border-b">
                <button className={`flex-1 py-2 text-center font-medium ${activeTab === 'now' ? 'border-b-2 border-indigo-600 text-indigo-600' : 'text-gray-500'}`} onClick={() => setActiveTab('now')}>Available Now</button>
                <button className={`flex-1 py-2 text-center font-medium ${activeTab === 'scheduled' ? 'border-b-2 border-indigo-600 text-indigo-600' : 'text-gray-500'}`} onClick={() => setActiveTab('scheduled')}>Schedule</button>
                <button className={`flex-1 py-2 text-center font-medium ${activeTab === 'club' ? 'border-b-2 border-indigo-600 text-indigo-600' : 'text-gray-500'}`} onClick={() => setActiveTab('club')}>Register Club</button>
            </div>
            <div className="w-full">
                {activeTab === 'club' ? (
                    <ClubForm
                        onSuccess={() => setActiveTab('now')}
                        onCancel={() => setActiveTab('now')}
                    />
                ) : (
                    <MeetupForm type={activeTab} />
                )}
            </div>
        </div>
    );
}

export default OpenToPlayTabs;